export enum ShippingMethodEnum {
  WAREHOUSE = 'Warehouse',
  DOORS = 'Doors',
  PICKUP = 'Pickup',
}
